import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { PAGE_BG, CARD_BG, BORDER, TEXT_MAIN, TEXT_MUTED, PRIMARY, PRIMARY_HOVER, CARD_RADIUS, FONT, FS_TITLE, FS_BODY, FS_LABEL } from './tokens';
import LanguageSwitcher from '../Topbar/LanguageSwitcher';

export default function QuizPrivacy({ policyText, title, showLanguage, onAccept, t }) {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', backgroundColor: PAGE_BG, fontFamily: FONT }}>
            <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', p: 3 }}>
                <Box
                    sx={{
                        width: '100%',
                        maxWidth: 1100,
                        backgroundColor: CARD_BG,
                        borderRadius: CARD_RADIUS,
                        border: `1px solid ${BORDER}`,
                        display: 'flex',
                        flexDirection: 'column',
                        maxHeight: '90vh',
                        overflow: 'hidden',
                    }}
                >
                    {showLanguage && (
                        <Box
                            sx={{
                                px: 3,
                                py: 1.5,
                                borderBottom: `1px solid ${BORDER}`,
                                flexShrink: 0,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                gap: 2,
                                backgroundColor: '#F8FAFC',
                            }}
                        >
                            <Typography sx={{ fontWeight: 600, fontSize: FS_LABEL, color: TEXT_MUTED }}>
                                {t('select_language')}
                            </Typography>
                            <LanguageSwitcher />
                        </Box>
                    )}
                    <Box sx={{ p: 3, borderBottom: `1px solid ${BORDER}`, flexShrink: 0 }}>
                        <Typography sx={{ fontWeight: 700, fontSize: FS_TITLE, color: TEXT_MAIN, textAlign: 'center' }}>
                            {title}
                        </Typography>
                    </Box>
                    <Box sx={{ p: 3, overflowY: 'auto', flex: 1 }}>
                        <Typography
                            component="pre"
                            sx={{
                                fontFamily: FONT,
                                fontSize: FS_BODY,
                                color: TEXT_MUTED,
                                lineHeight: 1.7,
                                whiteSpace: 'pre-wrap',
                                m: 0,
                            }}
                        >
                            {policyText}
                        </Typography>
                    </Box>
                    <Box sx={{ p: 3, borderTop: `1px solid ${BORDER}`, flexShrink: 0, display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                            variant="contained"
                            onClick={onAccept}
                            sx={{
                                backgroundColor: PRIMARY,
                                px: 4,
                                py: 1,
                                borderRadius: '8px',
                                fontWeight: 600,
                                fontSize: FS_BODY,
                                textTransform: 'none',
                                '&:hover': { backgroundColor: PRIMARY_HOVER },
                            }}
                        >
                            {t('accept')}
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}
